import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class WhInvenSumListItem extends SearchModelBase {
    centerNo: string = '';
    itemNo: string = '';
    itemDesc: string = '';
    upcCode: string = '';
    onHandQty: number|null = null;
    allQty: number|null = null;
    availQty: number|null = null;
    boxUnit: string = '';
    innerPcs: number|null = null;
    onHandPcs: number|null = null;
    allPcs: number|null = null;
    availPcs: number|null = null;
    id: number = 0;
    fromOnHandQty: number|null = null;
    toOnHandQty: number|null = null;
    fromAllQty: number|null = null;
    toAllQty: number|null = null;
    fromAvailQty: number|null = null;
    toAvailQty: number|null = null;
    fromInnerPcs: number|null = null;
    toInnerPcs: number|null = null;
    fromOnHandPcs: number|null = null;
    toOnHandPcs: number|null = null;
    fromAllPcs: number|null = null;
    toAllPcs: number|null = null;
    fromAvailPcs: number|null = null;
    toAvailPcs: number|null = null;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Customer', width: 100, dataIndex: 'centerNo', defaultColumnFocus : true}),
        XCol.Create({ col: 2, text: 'Prod Code/SKU', width: 120, dataIndex: 'itemNo'}),
        XCol.Create({ col: 3, text: 'Description', width: 150, dataIndex: 'itemDesc'}),
        XCol.Create({ col: 4, text: 'UPC/EAN', width: 80, dataIndex: 'upcCode'}),
        XCol.Create({ col: 5, text: 'On Hand Qty', width: 120, dataIndex: 'onHandQty', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 6, text: 'Allocated Qty', width: 120, dataIndex: 'allQty', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 7, text: 'Available Qty', width: 120, dataIndex: 'availQty', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 8, text: 'Unit', width: 60, dataIndex: 'boxUnit'}),
        XCol.Create({ col: 9, text: 'Inner Pack', width: 80, dataIndex: 'innerPcs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 10, text: 'On Hand Pcs', width: 120, dataIndex: 'onHandPcs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 11, text: 'Allocated Pcs', width: 120, dataIndex: 'allPcs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 12, text: 'Available Pcs', width: 120, dataIndex: 'availPcs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true }),
    ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: WhInvenSumListItem.prototype.itemNo, orderByAscending: true };

    public static formatData(data: WhInvenSumListItem[]) {
        return data.map((d: WhInvenSumListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        onHandQty: {from: 'fromOnHandQty', to: 'toOnHandQty'},
        allQty: {from: 'fromAllQty', to: 'toAllQty'},
        availQty: {from: 'fromAvailQty', to: 'toAvailQty'},
        innerPcs: {from: 'fromInnerPcs', to: 'toInnerPcs'},
        onHandPcs: {from: 'fromOnHandPcs', to: 'toOnHandPcs'},
        allPcs: {from: 'fromAllPcs', to: 'toAllPcs'},
        availPcs: {from: 'fromAvailPcs', to: 'toAvailPcs'},
    }
}
